export const panelWithoutHeaderHeight = 'calc(100vh - 168px)'; // 215px positions the panel correctly in the local panel
